import ReactSwitch from "react-switch";
import styled, { useTheme } from "styled-components";
import { FontWeight, UIToggle } from "../types";
import { Text } from "./Text";

type ToggleProps = {
  id: string;
  toggle: UIToggle;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function Toggle({ id, toggle, checked, onChange }: ToggleProps) {
  const theme = useTheme();

  const width = theme.isMobile ? theme.getValue(42) : theme.getValue(66);
  const height = theme.isMobile ? theme.getValue(24) : theme.getValue(38);
  const diameter = height - 4;
  const onColor = toggle.onColor?.hex || theme.colors.green2;
  const offColor = toggle.offColor?.hex || theme.colors.grey8;

  return (
    <Container>
      <ReactSwitch
        id={id}
        checked={checked}
        onChange={onChange}
        checkedIcon={false}
        uncheckedIcon={false}
        width={width}
        height={height}
        handleDiameter={diameter}
        onColor={onColor}
        offColor={offColor}
      />
      <Label as="label" htmlFor={id}>
        {toggle.label.value}
      </Label>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: ${({ theme }) => (theme.isMobile ? "column" : "row")};
  align-items: ${({ theme }) => (theme.isMobile ? "flex-start" : "center")};
  margin-left: ${({ theme }) => (theme.isMobile ? theme.getValue(20) : 0)}px;
`;

const Label = styled(Text)`
  &&& {
    font-weight: ${({ font: { weight = FontWeight.Bold } = {} }) => weight};
    font-size: ${({ theme }) =>
      theme.isMobile ? theme.getFontSize(14) : theme.getFontSize(22)}px;
    margin-top: ${({ theme }) => (theme.isMobile ? theme.getValue(10) : 0)}px;
    margin-left: ${({ theme }) => (theme.isMobile ? 0 : theme.getValue(24))}px;
  }
`;
